import { render, staticRenderFns } from "./CoursewareShelfDialogImport.vue?vue&type=template&id=1a82c08a&"
import script from "./CoursewareShelfDialogImport.vue?vue&type=script&lang=js&"
export * from "./CoursewareShelfDialogImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports